/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * Request to grant early access to a feature for a tenant
 * @export
 * @interface GrantEarlyAccessRequest
 */
export interface GrantEarlyAccessRequest {
    /**
     * Tenant ID
     * @type {string}
     * @memberof GrantEarlyAccessRequest
     */
    tenantId: string;
    /**
     * Feature ID
     * @type {string}
     * @memberof GrantEarlyAccessRequest
     */
    featureId: string;
    /**
     * Release state: ALPHA, BETA, GA, PLANNED
     * @type {string}
     * @memberof GrantEarlyAccessRequest
     */
    releaseState?: string;
    /**
     * User or system that granted access
     * @type {string}
     * @memberof GrantEarlyAccessRequest
     */
    grantedBy?: string;
    /**
     * Expiry time (ISO-8601). Null = no expiry.
     * @type {Date}
     * @memberof GrantEarlyAccessRequest
     */
    expiresAt?: Date;
    /**
     * Reason for grant
     * @type {string}
     * @memberof GrantEarlyAccessRequest
     */
    reason?: string;
}

/**
 * Check if a given object implements the GrantEarlyAccessRequest interface.
 */
export function instanceOfGrantEarlyAccessRequest(value: object): value is GrantEarlyAccessRequest {
    if (!('tenantId' in value) || value['tenantId'] === undefined) return false;
    if (!('featureId' in value) || value['featureId'] === undefined) return false;
    return true;
}

export function GrantEarlyAccessRequestFromJSON(json: any): GrantEarlyAccessRequest {
    return GrantEarlyAccessRequestFromJSONTyped(json, false);
}

export function GrantEarlyAccessRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): GrantEarlyAccessRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'],
        'featureId': json['featureId'],
        'releaseState': json['releaseState'] == null ? undefined : json['releaseState'],
        'grantedBy': json['grantedBy'] == null ? undefined : json['grantedBy'],
        'expiresAt': json['expiresAt'] == null ? undefined : (new Date(json['expiresAt'])),
        'reason': json['reason'] == null ? undefined : json['reason'],
    };
}

export function GrantEarlyAccessRequestToJSON(json: any): GrantEarlyAccessRequest {
    return GrantEarlyAccessRequestToJSONTyped(json, false);
}

export function GrantEarlyAccessRequestToJSONTyped(value?: GrantEarlyAccessRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'featureId': value['featureId'],
        'releaseState': value['releaseState'],
        'grantedBy': value['grantedBy'],
        'expiresAt': value['expiresAt'] == null ? undefined : ((value['expiresAt']).toISOString()),
        'reason': value['reason'],
    };
}

